export default "__VITE_ASSET__DK6u2oao__"